import api from '@/api';
import { API_BASE_URL } from '../../index';
import { QuestCommissionByMovementRequest } from './CommissionByMovement.types';

const CONTROLLER_URL = `${API_BASE_URL}/Reports`;

export async function getQuestReportCommissionByMovement(
  params: QuestCommissionByMovementRequest,
) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/CommissionByMovement`,
    params,
  )) as unknown;

  return result as BlobPart;
}
